/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { escapeEmail } from '@touchplan/common';

export class StringUtils {
	/**
	 * supplant replaces expression eclosed in {} braces in target string
	 *
	 * @param {string} str - target string to supplant
	 * @param {...string} args - array of strings to replace {} with
	 * @return {string} supplanted string
	 *
	 * @example
	 * let test = "{0} test2 {1}"
	 * StringUtils(test, "test1", "test3");
	 * retuns:
	 * "test1 test2 test3"
	 */
	public static supplant = (str: string, ...args: string[]) => {
		if (args.length === 0) {
			return '';
		}

		str = str.slice();
		for (let i = 0; i < args.length; i++) {
			str = str.replace(new RegExp('\\{' + i + '\\}'), args[i]);
		}
		return str;
	};

	/**
	 * This method extracts the domain from a provided email and also make it safer to use as Firebase key
	 * This Escapes $, [, ], /, #. Using url encoding + “dot to comma”
	 */
	public static getDomainKeyFromEmail(email: string): string {
		const [_, domain] = email.split('@');
		return domain ? escapeEmail(domain) : null;
	}
}
